/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetType } from './rolloutTargetType';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { RolloutTargetSpec } from './rolloutTargetSpec';


/**
 * Specification to target deployment targets.
 */
export interface DeploymentTargetSpec extends RolloutTargetSpec { 
    provider_type: CloudProvidersEnum;
    versions: Array<string>;
}
export namespace DeploymentTargetSpec {
}


